// store.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    // addMessage: (state, action) => {
    //   const { viewId, message } = action.payload;
    //   if (!state[viewId]) {
    //     state[viewId] = [];
    //   }
    //   state[viewId].push(message);
    // }
    addMessage: (state, action) => {
      const { viewId, message, sender } = action.payload;
      if (!state[viewId]) {
        state[viewId] = [];
      }
      state[viewId].push({ text: message, sender: sender });
    }
  }
});

export const { addMessage } = chatSlice.actions;
export default chatSlice.reducer;